const frequencyCap = {
    INDEX: '/frequency-cap',
  }
  
  export default frequencyCap
  